(function() {
  'use strict';

  // Tier-Config kommt dynamisch aus window.__b2bTierConfig (vom Theme injected)
  var config = (window.__b2bConfig && window.__b2bConfig.tier_config) || window.__b2bTierConfig || {};
  // Format: { silver: { type, value, scope, productIds, active }, ... }

  function log() { console.log.apply(console, ['[B2B-Disc]'].concat([].slice.call(arguments))); }

  var raw = (window.__b2bConfig && window.__b2bConfig.customer && window.__b2bConfig.customer.tags) || window.__customerTags;
  var tags = [];
  if (Array.isArray(raw)) tags = raw.map(function(t) { return String(t).trim(); });
  else if (typeof raw === 'string' && raw) tags = raw.split(',').map(function(t) { return t.trim(); });

  // Match: für jeden Customer-Tag schauen ob ein b2b-XXX Tag zu einem active Tier passt
  var activeTier = null;
  var activeRule = null;
  for (var i = 0; i < tags.length; i++) {
    var t = tags[i];
    if (t.indexOf('b2b-') !== 0) continue;
    var key = t.slice(4); // 'b2b-silver' -> 'silver'
    if (key === 'verified') continue;
    if (config[key] && config[key].active) {
      activeTier = key;
      activeRule = config[key];
      break;
    }
  }

  if (!activeTier) { log('no active tier matched for tags', tags); }
  else { log('active tier:', activeTier, '→', activeRule); }

  // === Discount-Code automatisch applien ===
  if (activeTier) {
    var code = 'B2B-' + activeTier.toUpperCase();
    var lastApplyTs = 0;
    var applying = false;

    function checkAndApply(force) {
      if (applying) return;
      var now = Date.now();
      if (!force && now - lastApplyTs < 2000) return;
      applying = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var apps = (cart.cart_level_discount_applications || []).map(function(d){return d.code || d.title}).join(',');
          if (apps.toUpperCase().indexOf(code) !== -1) {
            log('discount already applied');
            applying = false; return;
          }
          var ifr = document.createElement('iframe');
          ifr.style.cssText = 'position:absolute;width:1px;height:1px;border:0;visibility:hidden;left:-9999px;top:-9999px';
          ifr.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
          var done = false;
          ifr.onload = function() {
            if (done) return; done = true;
            setTimeout(function() {
              try { ifr.remove(); } catch(e) {}
              fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
                var v = (c.cart_level_discount_applications || []).map(function(d){return d.title}).join(',');
                log('after apply — discounts:', v || '(none)', 'total:', c.total_price);
                window.dispatchEvent(new CustomEvent('cart:refresh'));
                applying = false;
                lastApplyTs = Date.now();
              });
            }, 600);
          };
          document.body.appendChild(ifr);
          setTimeout(function() {
            if (done) return;
            try { ifr.remove(); } catch(e) {}
            applying = false;
          }, 5000);
        })
        .catch(function(e) { log('cart.js err', e); applying = false; });
    }

    setTimeout(function() { checkAndApply(true); }, 600);

    var origFetch = window.fetch;
    window.fetch = function() {
      var url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change)(\.js)?/.test(url)) {
        p.then(function() { setTimeout(function(){ checkAndApply(false); }, 500); });
      }
      return p;
    };
  }

  // === STREICHPREIS-RENDERER ===
  // Berechnet client-seitig den rabattierten Preis und rendert ihn auf Produktkarten + Produkt-Detail
  function computeDiscounted(originalCents, rule) {
    if (!rule || !rule.active) return originalCents;
    if (rule.type === 'percentage') {
      var pct = Math.max(0, Math.min(100, rule.value));
      return Math.round(originalCents * (1 - pct / 100));
    }
    if (rule.type === 'amount') {
      var offCents = Math.round(rule.value * 100);
      return Math.max(0, originalCents - offCents);
    }
    return originalCents;
  }

  function shouldApplyToProduct(productGid, variantGid, rule) {
    if (!rule) return false;
    if (rule.scope === 'all') return true;
    var ids = rule.productIds || [];
    if (rule.scope === 'products') return ids.indexOf(productGid) !== -1 || ids.indexOf(variantGid) !== -1;
    if (rule.scope === 'exclude') return ids.indexOf(productGid) === -1 && ids.indexOf(variantGid) === -1;
    return false;
  }

  function fmtEur(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function renderStrikethrough(priceEl, originalCents, newCents) {
    if (priceEl.dataset.b2bRendered === '1') return;
    var pct = activeRule.type === 'percentage' ? activeRule.value : Math.round((1 - newCents / originalCents) * 100);
    var origStr = priceEl.textContent.trim();
    var html = '<s style="opacity:0.6;font-weight:400;text-decoration:line-through;margin-right:6px">' + origStr + '</s>' +
               '<span style="color:#E85D3F;font-weight:700">' + fmtEur(newCents) + '</span>' +
               '<div style="font-size:11px;color:#E85D3F;font-weight:600;margin-top:2px">B2B ' + activeTier + ' −' + pct + '%</div>';
    priceEl.innerHTML = html;
    priceEl.dataset.b2bRendered = '1';
    priceEl.dataset.b2bOriginal = originalCents;
  }

  function scanAndRender() {
    if (!activeTier) return;
    // Alle <span class="price"> auf der Page
    var priceSpans = document.querySelectorAll('span.price:not([data-b2b-rendered])');
    priceSpans.forEach(function(span) {
      // Finde Original-Preis im Text — z.B. "€23,00" → 2300
      var m = span.textContent.replace(/\s/g, '').match(/([0-9.,]+)/);
      if (!m) return;
      var num = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
      if (isNaN(num) || num <= 0) return;
      var origCents = Math.round(num * 100);
      // Best-effort: scope=all → immer; scope=products/exclude → wir können hier ohne ProductID nicht entscheiden
      // → für MVP: nur scope=all
      if (activeRule.scope !== 'all') return;
      var newCents = computeDiscounted(origCents, activeRule);
      if (newCents >= origCents) return;
      renderStrikethrough(span, origCents, newCents);
    });
  }

  // Initial + nach DOM-Changes (Cart-Drawer, Variant-Switch, etc.)
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(scanAndRender, 300);
  } else {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(scanAndRender, 300); });
  }

  // Re-Scan bei dynamischen Updates
  var mo = new MutationObserver(function(mutations) {
    var hasNewPrice = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if (n.matches && (n.matches('span.price') || n.querySelector && n.querySelector('span.price'))) hasNewPrice = true;
      });
    });
    if (hasNewPrice) setTimeout(scanAndRender, 100);
  });
  mo.observe(document.body, { childList: true, subtree: true });

  log('B2B Pricing initialized — tier:', activeTier);
})();
